<template>
	<div class="customers">
		<v-layout wrap justify-end
			align-center class="header-booking-data">
			<amounts-component :subsidiary-id="subsidiary" />
			<v-flex xs2>
				<v-select
					class="filter-select mr3"
					hide-details
					:items="subsidiaries"
					item-text="name"
					item-value="id"
					v-model="subsidiary"
					single-line
					@change="filterByHotel"
				>
				</v-select>
			</v-flex>
		</v-layout>
		<v-layout row wrap mb-3>
			<v-flex md7>
				<v-layout wrap align-center>
					<v-flex xs7 pr-5>
						<v-layout row wrap class="calendar-range">
							<v-flex md6 pa-0 class="border-right">
								<v-menu
									lazy
									v-model="menuStart"
									transition="scale-transition"
									offset-y
									full-width
									:nudge-left="40"
									class="menu-date-picker"
									max-width="290px"
									@input="changeIcon">
									<v-text-field
										slot="activator"
										label="Check In"
										v-model="dateStart"
										:disabled="!dateStart"
										prepend-icon="event"
										:append-icon="arrowIconStart"
										:append-icon-cb="toggleIconStartDate"
										single-line
										hide-details
										readonly
									></v-text-field>
									<v-date-picker
										v-model="dateStart"
										locale="es-PE"
										no-title
										scrollable
										@input="disabled">
									</v-date-picker>
								</v-menu>
							</v-flex>
							<v-flex md6 pa-0>
								<v-menu
									lazy
									v-model="menuEnd"
									transition="scale-transition"
									offset-y
									full-width
									class="menu-date-picker"
									max-width="290px"
									:disabled="!dateStart"
									@input="changeEndIcon">
									<v-text-field
										slot="activator"
										label="Check Out"
										v-model="dateEnd"
										:append-icon="arrowIconEnd"
										:append-icon-cb="toggleIconEndDate"
										single-line
										hide-details
										readonly
									></v-text-field>
									<v-date-picker
										v-model="dateEnd"
										locale="es-PE"
										no-title
										scrollable
										@input="filterData">
									</v-date-picker>
								</v-menu>
							</v-flex>
						</v-layout>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex md3>
				<section class="filters-by-time">
					<v-btn v-for="filter in filtersButtons"
						:key="filter.id"
						:class="{'activeBtn': filter.id === value}"
						@click="onDateFilter(filter)"
						:disabled="loading">
						{{filter.label}}
					</v-btn>
				</section>
			</v-flex>
			<v-flex md2 class="text-xs-right">
				<button-create text="Crear reserva" :href="createHref"></button-create>
			</v-flex>
		</v-layout>
		<v-tabs class="checkin-tabs"
			v-model="active">
			<v-tabs-bar class="transparent mb-5">
				<v-tabs-slider class="default-skyblue"></v-tabs-slider>
				<v-tabs-item
					v-for="item in filters"
					:key="item.id"
					:href="`#${item.id}`"
				>
					{{ item.name }}
				</v-tabs-item>
			</v-tabs-bar>
			<v-tabs-items>

				<v-tabs-content v-for="fil in filters"
					:key="fil.id"
					:id="`${fil.id}`"
				>
					<booking-table
						:columns="columns"
						:rows="rows"
						:total-pages="totalPages"
						:current-tab="active"
						:subsidiary-id="subsidiary"
						@sortable-event="columnSortableEvent"
						@search-event="searchByColumn"
						@delete-event="deleteRow"
						@custom-button="customButton"
						@input="loadData"
						@updated-booking-status="bookingStatusUpdated"
					/>
				</v-tabs-content>
			</v-tabs-items>
		</v-tabs>
	</div>
</template>

<script>
import { addDays, format } from 'date-fns';
import helper from '@/shared/helper';
import mixin from '@/shared/mixins';
import lib from '@/shared/lib';
import ButtonCreate from '@/components/shared/ButtonCreate';
import amountsComponent from '@/components/shared/AmountsComponent';
import FilterList from '@/components/shared/FilterList';
import bookingTable from '@/clerkinn/bookings/sub-component/booking-table';

const helperMethods = helper.methods;
const { removeItemFromArray } = lib;

function disabled() {
	this.value = 0;
	this.loadData();
}

function created() {
	this.loadHotels();
}

function arrowIconEnd() {
	const arrow = this.onChangeEnd ? 'arrow_drop_up' : 'arrow_drop_down';
	return arrow;
}

function arrowIconStart() {
	const arrow = this.onChange ? 'arrow_drop_up' : 'arrow_drop_down';
	return arrow;
}

function changeEndIcon(result) {
	this.onChangeEnd = result;
}

function changeIcon(result) {
	this.onChange = result;
}

function columnSortableEvent({ id }) {
	const self = this;
	const newColumn = self.columns.filter(column => column.id === id);
	newColumn[0].isSortable = newColumn[0].isSortable.down ?
		{ down: false, up: true } : { down: true, up: false };
	self.columns = self.columns.map((columnSingle) => {
		const newColumnSingle = Object.assign({}, columnSingle);
		if (columnSingle.id !== newColumn[0].id) {
			newColumnSingle.isSortable = { down: true, up: false };
		}
		return newColumnSingle;
	});
	this.params.sortField = newColumn[0].code;
	this.params.sortDirection = newColumn[0].isSortable.up ? 'asc'
		: 'desc';
	this.loadData();
}

function customButton({ btn, row }) {
	if (row.booking_state !== 'Anulada') {
		if (btn.id === 1) {
			this.$router.push({ name: 'booking-edit', params: { codeBooking: row.code } });
		} else if (btn.id === 2) {
			const query = {
				bookingCode: row.code,
				initDate: row.bookingStart,
				endDate: row.bookingEnd,
				roomId: row.room.data.id,
			};
			const params = {
				hotelId: this.params.idHotel,
				roomTypeId: row.room.data.roomTypes.data.id,
			};
			this.$router.push({ name: 'checkin-form-tabs', params, query });
		} else if (btn.id === 3) {
			this.downloadCardTravel(row);
		} else if (btn.id === 4) {
			this.downLoadReservationAccount(row);
		}
	}	else {
		this.showNotification('La reserva ya ha sido anulada');
	}
}

async function deleteRow(row) {
	if (Number(row.bookingState) === 2) {
		this.showNotification('Las reservas confirmadas no pueden ser eliminadas.', 'warning');
	} else {
		await this.$http.delete(`bookings/${row.id}`);
		this.showNotification('La reserva ha sido eliminada.', 'success');
		this.loadData();
	}
}

async function downloadCardTravel({ code }) {
	const baseUrl = process.env.PMS_URL;
	const typeDocumentCode = 'registerCard';
	const name = `TARJETA-DE-EMBARQUE${code}`;
	const responseType = 'blob';
	const cardModel = { details: [{}] };
	const response = await this.$http.post(`${baseUrl}/booking/${code}/report/${typeDocumentCode}`,
		cardModel, { responseType });
	const blob = helperMethods.generateBlob(response.bodyBlob);
	helperMethods.showDownloadDialog(blob, name, 'pdf');
}

async function downLoadReservationAccount({ code }) {
	const baseUrl = process.env.PMS_URL;
	const name = `ESTADO-DE-CUENTA-RESERVA-${code}`;
	const responseType = 'blob';
	const cardModel = { details: [{}] };
	const response = await this.$http.post(
		`${baseUrl}/report/accountStatus?codeBooking=${code}&format=Tabloid`,
		cardModel,
		{ responseType },
	);
	const blob = helperMethods.generateBlob(response.body);
	helperMethods.showDownloadDialog(blob, name, 'pdf');
}

function filterByHotel(id) {
	this.params.idHotel = id;
	this.loadData();
}

function filterData(endDate) {
	this.params.checkIn = this.dateStart;
	this.params.checkOut = endDate;
	this.loadData();
}

async function loadData(page = 1) {
	this.params.page = page;
	const response = await this.$http.get(`${process.env.PMS_URL}/bookings`, { params: this.params });
	this.totalPages = response.data.meta.pagination.total_pages;
	this.rows = response.data.data.map((row) => {
		const newRow = { ...row };
		newRow.employee_name = `${row.employee.data.name}`;
		const states = this.filters.filter(fil => fil.id > 0);
		const stateSelected = states.find(state => state.id === Number(row.bookingState)) || {};
		newRow.booking_state = stateSelected.name;
		return newRow;
	});
	if (this.rows.length === 0) {
		this.showNotification('No se encontraron reservas para el hotel seleccionado en el estado elegido.',
			'info');
	}
	this.columns = [
		{ id: 1, name: '# Rva', code: 'code', isSortable: { down: true, up: false } },
		{ id: 2, name: 'Estado', code: 'booking_state', isSortable: { down: true, up: false } },
		{ id: 3, name: 'Nombre', code: 'full_name', isSortable: { down: true, up: false } },
		{ id: 4, name: 'País', code: 'country', isSortable: { down: true, up: false } },
		{ id: 5, name: 'Canal de Rva', code: 'company_name', isSortable: { down: true, up: false } },
		{ id: 6, name: 'Hab.', code: 'code_roomtype', isSortable: { down: true, up: false } },
		{ id: 7, name: 'Check In', code: 'booking_start', isSortable: { down: true, up: false } },
		{ id: 8, name: 'Noches', code: 'number_nights', isSortable: { down: true, up: false } },
		{ id: 9, name: 'Check out', code: 'booking_end', isSortable: { down: true, up: false } },
		{ id: 10, name: 'Empleado', code: 'employee_id', isSortable: { down: true, up: false } },
		{ id: 11, name: 'Total', code: 'total', isSortable: { down: true, up: false } },
		{ id: 12, name: '', code: 'payment_id', isSortable: { down: false, up: false } },
	];
	this.loading = false;
}

async function loadFilters() {
	const { data: filters } = await this.$http.get(`${process.env.PMS_URL}/booking/status`, { params: this.params });
	const updatedFilters = removeItemFromArray('name', 'Confirmadas')(filters.data);
	this.filters = [
		{ id: 0, name: 'Todos' },
	];
	this.filters = this.filters.concat(updatedFilters);
	this.filter = this.filters[0].id;
	this.active = `${this.filter}`;
}

async function loadHotels() {
	const response = await this.$http.get(`${process.env.PMS_URL}/hotel`);
	this.subsidiaries = response.data.data || [];
	this.subsidiary = response.data.data[0] ? response.data.data[0].id : 0;
	if (this.subsidiary > 0) {
		this.params.idHotel = this.subsidiary;
		this.loadFilters();
	}
}

function searchByColumn(search) {
	this.params.search = search;
	this.loadData();
}

function toggleIconEndDate() {
	this.onChangeEnd = !this.endDate;
}

function toggleIconStartDate() {
	this.onChange = !this.startDate;
}

function onDateFilter(filter) {
	this.value = filter.id;
	if (this.value === 1) {
		this.dateStart = format(new Date(), 'YYYY-MM-DD');
	} else {
		this.dateStart = format(addDays(new Date(), 1), 'YYYY-MM-DD');
	}
	this.dateEnd = format(addDays(this.dateStart, 1), 'YYYY-MM-DD');
	this.filterData(this.dateEnd);
	this.loadData();
}

function selectedFilter(id) {
	this.params.bookingState = id === '0' ? null : id;
	this.rows = [];
	this.loadData();
}

function active(newValue) {
	this.selectedFilter(newValue);
}

function bookingStatusUpdated() {
	this.loadData();
}

function data() {
	return {
		active: '',
		createHref: { name: 'booking-new' },
		columns: [
			{ id: 1, name: '# Rva', code: 'code', isSortable: { down: true, up: false } },
			{ id: 2, name: 'Estado', code: 'booking_state', isSortable: { down: true, up: false } },
			{ id: 3, name: 'Nombre', code: 'full_name', isSortable: { down: true, up: false } },
			{ id: 4, name: 'País', code: 'country', isSortable: { down: true, up: false } },
			{ id: 5, name: 'Canal de Rva', code: 'company_name', isSortable: { down: true, up: false } },
			{ id: 6, name: 'Hab.', code: 'code_roomtype', isSortable: { down: true, up: false } },
			{ id: 7, name: 'Check In', code: 'booking_start', isSortable: { down: true, up: false } },
			{ id: 8, name: 'Noches', code: 'number_nights', isSortable: { down: true, up: false } },
			{ id: 9, name: 'Check out', code: 'booking_end', isSortable: { down: true, up: false } },
			{ id: 10, name: 'Empleado', code: 'employee_id', isSortable: { down: false, up: false } },
			{ id: 11, name: 'Total', code: 'total', isSortable: { down: false, up: false } },
			{ id: 12, name: '', code: 'payment_id', isSortable: { down: false, up: false } },
		],
		dateEnd: format(addDays(new Date(), 1), 'YYYY-MM-DD'),
		dateStart: format(addDays(new Date(), 0), 'YYYY-MM-DD'),
		date: format(new Date(), 'YYYY-MM-DD'),
		defaultTab: '0',
		filters: [],
		filtersButtons: [
			{
				id: 1, value: 1, label: 'Hoy',
			},
			{
				id: 2, value: 2, label: 'Mañana',
			},
		],
		loading: false,
		menuEnd: false,
		menuStart: false,
		onChange: false,
		onChangeEnd: false,
		params: {
			checkIn: format(addDays(new Date(), 0), 'YYYY-MM-DD'),
			checkOut: format(addDays(new Date(), 1), 'YYYY-MM-DD'),
			bookingState: null,
			idHotel: 0,
			page: 1,
			perPage: 10,
			search: null,
			sortField: null,
			sortDirection: null,
		},
		rows: [],
		subsidiaries: [],
		subsidiary: 0,
		totalPages: 1,
		optionButtons: [],
		value: 1,
	};
}

export default {
	name: 'booking-list',
	components: {
		amountsComponent,
		bookingTable,
		ButtonCreate,
		FilterList,
	},
	computed: {
		arrowIconEnd,
		arrowIconStart,
	},
	created,
	data,
	methods: {
		disabled,
		bookingStatusUpdated,
		changeEndIcon,
		changeIcon,
		columnSortableEvent,
		customButton,
		deleteRow,
		downloadCardTravel,
		downLoadReservationAccount,
		filterByHotel,
		filterData,
		loadData,
		loadFilters,
		loadHotels,
		onDateFilter,
		searchByColumn,
		selectedFilter,
		toggleIconEndDate,
		toggleIconStartDate,
	},
	mixins: mixin,
	watch: {
		active,
	},
};
</script>

<style lang="scss" scoped>
	.header-booking-data {
		height: 31px;
		position: absolute;
		right: 20px;
		text-align: right;
		top: 55px;
		width: calc(100% - 230px);

		div {
			padding-bottom: 0px !important;
			padding-top: 0px !important;
		}

		p {
			color: map-get($colors, blue-title);
			font-family: map-get($fonts, regular);
			font-size: 10px;
			margin: 0px;
			text-transform: uppercase;
		}

		span {
			color: map-get($colors, default-skyblue);
			font-family: map-get($fonts, medium);
			font-size: 15px;
		}

		.border-select {
			border-right: 1px solid map-get($colors, border-radio);
			margin-right: 16px;
			padding-right: 16px !important;
		}
	}

	.border-right {
		border-right: 1px solid map-get($map: $colors, $key: e-bg-icon);
	}
</style>



// WEBPACK FOOTER //
// List.vue?e007453e